import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavigationBar from "../components/NavigationBar.js";
import MainSection from "../components/MainSection.js";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js"
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import SeriesInfo from "../components/SeriesInfo.js";
import Calendar from "../components/Calendar.js";
import SeriesList from "../components/SeriesList.js";
import PopularItems from "../components/PopularItems.js";
import MobileItems from "../components/MobileItems.js";
import { filterByStatus } from "../utils/filterByStatus.js";
import RowCalendar from "../components/RowCalendar.js";
import Loader from "../components/Misc/Loader.js";

export default function MainPage() {
    const location = useLocation();
    const navigate = useNavigate();
    
    const serStore = seriesStore();
    const staStore = statusStore();
    const seaStore = seasonStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);

    const [navOpen, setNavOpen] = useState(null);

    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
        staStore.fetchStatus();
        seaStore.fetchSeason();
    }, []);

    useEffect(() => {
        if (!selectedShow?._id) return;
    }, [selectedShow?._id, staStore.status]);

    useEffect(() => {
        if (location.state?.selectedShow) {
            setSelectedShow(location.state.selectedShow);
        }
        if (location.state?.selectedSeriesList) {
            setSelectedSeriesList(location.state.selectedSeriesList);
        }
        if (location.state?.activeHeader) {
            setActiveHeader(location.state.activeHeader);
        }
    }, [location.state]);

    //const loading = serStore.loading || staStore.loading || seaStore.loading;
    // const loading = serStore.loading;
    // if (loading) return <Loader />;

    //testing
    const { filteredSeries: startedSeries, filteredSeasons: startedSeasons } =
          filterByStatus(staStore.status, serStore.series, "Started");

    return (
        <div className="app-wrapper tv-static">
            <header class="header">
                <Header 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                />
            </header>    
            <content className="content">
                <nav className="nav">
                    <NavigationBar 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                    />
                </nav>
                <main className="main">
                    <div>
                        {activeHeader === "Calendar" ? (
                        <div className="midSection"><div className="midSectionHeader">
                            <Calendar
                                selectedShow={selectedShow}
                                activeHeader={activeHeader}
                                setActiveHeader={setActiveHeader} />
                            </div>
                        </div>
                        ) : selectedSeriesList ? (
                        <div className="midSection"><div className="midSectionHeader">
                            <SeriesList 
                                activeHeader={activeHeader}
                                setActiveHeader={setActiveHeader}
                                selectedShow={selectedShow}
                                setSelectedShow={setSelectedShow}
                                selectedSeriesList={selectedSeriesList}
                                setSelectedSeriesList={setSelectedSeriesList}
                            />
                            </div>
                            </div>
                        ) : (
                        <div>
                            <div className="desktopMainSection">
                                <PopularItems 
                                activeHeader = {activeHeader}
                                setActiveHeader={setActiveHeader}
                                selectedShow={selectedShow}
                                setSelectedShow={setSelectedShow}
                                selectedSeriesList={selectedSeriesList}
                                setSelectedSeriesList={setSelectedSeriesList}/> 
                            </div> 
                            <div className="mobileMainSection">
                            {/* on mobile, the nav should be on the main area instead of the left panel */}  
                                <RowCalendar
                                    selectedShow={selectedShow}
                                    activeHeader={activeHeader}
                                    setActiveHeader={setActiveHeader} 
                                    />
                                <MobileItems 
                                    activeHeader = {activeHeader}
                                    setActiveHeader={setActiveHeader}
                                    selectedShow={selectedShow}
                                    setSelectedShow={setSelectedShow}
                                    selectedSeriesList={selectedSeriesList}
                                    setSelectedSeriesList={setSelectedSeriesList}/> 
                                <PopularItems 
                                    activeHeader = {activeHeader}
                                    setActiveHeader={setActiveHeader}
                                    selectedShow={selectedShow}
                                    setSelectedShow={setSelectedShow}
                                    selectedSeriesList={selectedSeriesList}
                                    setSelectedSeriesList={setSelectedSeriesList}/> 
                            </div> 
                        </div>
                        )}
                </div>
                </main>
                <aside className="right">
                    <div className="rightPanel">
                    </div>
                </aside>
            </content>
            <div class="footer"><Footer/></div>
        </div>
    )
}